import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight, Colors } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    marginBottom: 50,
  },
  sectionTitle: {
    textTransform: 'uppercase',
    fontWeight: `${FontWeight.Bold} !important`,
    fontSize: '13px !important',
    color: `${Colors.Gray} !important`,
    marginBottom: '30px !important',
  },
  sectionItemLink: {
    display: 'flex',
    alignItems: 'center',
  },
  sectionItemSwitch: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: 30,
  },
  sectionItemDisabled: {
    opacity: 0.44,
    '& $sectionItemStatus': {
      border: `1px solid ${Colors.Gray6}`,
      backgroundColor: 'transparent',
    },
  },
  sectionItem: {
    fontSize: '14px !important',
    fontWeight: `${FontWeight.Regular} !important`,
    color: `${Colors.Gray4} !important`,
    marginLeft: '10px !important',
  },
  sectionItemActive: {
    '& > p': {
      color: `${Colors.Blue1} !important`,
    },
    '& > span': {
      backgroundColor: `${Colors.Blue1} !important`,
      '& > p': {
        color: `${Colors.White} !important`,
      },
    },
  },
  sectionItemStatus: {
    minHeight: 24,
    minWidth: 24,
    backgroundColor: Colors.Gray2,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  isValidIcon: {
    minHeight: 24,
    minWidth: 24,
  },
  isErrorIcon: {
    minHeight: 28,
    minWidth: 28,
    color: Colors.Red,
  },
  sectionItemStatusContent: {
    fontSize: 12,
    color: Colors.Gray,
  },
  sectionItemStatusContentDisabled: {
    borderBottom: `1px solid ${Colors.Gray6}`,
    width: 10,
  },
}));

export default useStyles;
